import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, Col, Row, OverlayTrigger, Popover, Button, Form, Spinner, InputGroup } from 'react-bootstrap';
import printJS from 'print-js';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { BsCurrencyDollar } from 'react-icons/bs';
import classNames from 'classnames';
import toast, { Toaster } from 'react-hot-toast';
import { AiFillPrinter, AiOutlineStop } from 'react-icons/ai';
import icoFib from '../../images/icofiber.png';
import { AuthContext } from '../../auth/AuthContext';
import { useForm } from '../../hooks/useForm';
import { useContextInfo } from '../../context/ContextInfo';
import BadgetInternet from './pago/BadgetInternet';
import BadOtros from './pago/BadOtros';
import BadCarSal from './pago/BadCarSal';
import { fetchConToken } from '../../api/fetch';
import ModalScreen from './pago/ModalScreen';
import { checkAccess } from '../../helpers/details';

const RegPago = ({ data, show, onClear }) => {
    const { setResp } = useContextInfo();
    const [send, setSend] = useState(false);
    const [validated, setValidated] = useState(false);

    const [pdf, setPdf] = useState('pos');
    const toastId = useRef(null);
    const [meses, setMeses] = useState(0);
    const [total, setTotal] = useState('');
    const [folEx, setFolEx] = useState(false);
    const [bon, setBon] = useState(0);
    const [fecha, setfecha] = useState('');
    const [pinfo, setPinfo] = useState({});

    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Registrar pago', auth.accesos);
    const navigate = useNavigate();
    if (!permisos.access) navigate(`/`);
    const { cargos = [], saldos = [], datos = {}, otros = [], tipo = {}, speed = {}, planes = [] } = data;
    const {
        estado = '',
        fechapago = '',
        nombre = '',
        tlcargo = 0, //!cargos tl
        tlsaldo = 0, //!saldos tl
    } = datos;
    const { costo } = pinfo;

    const [values, handleInputChange, reset, setFormValue] = useForm({
        forma_pago: 'Efectivo Oficina/Sucursal',
        folio: '',
        pagado: '',
        saldo: '',
        cargo: '',
        subtotal: '',
        nota: '',
    });
    const { pagado, saldo, forma_pago, cargo } = values;

    useEffect(() => {
        setPinfo(speed);
    }, [speed]);

    useEffect(() => {
        if (!show) {
            reset();
            setfecha('');
            setMeses(0);
            // setShow();
            setFolEx(false);
            setPdf('pos');
            setTotal('');
            setBon(false);
            onClear();
        }
        if (show) setMeses(1);
    }, [show]);
    useEffect(() => {
        forma_pago !== 'Efectivo Oficina/Sucursal' && forma_pago !== 'Efectivo Oficina/Sucursal 5512'
            ? setFolEx(true)
            : setFolEx(false);
    }, [forma_pago]);

    useEffect(() => {
        totalAdd();
    }, [meses, fechapago]);

    useEffect(() => {
        processTl();
    }, [meses, costo]);
    useEffect(() => {
        setTotal(total - bon);
        processTl();
    }, [bon]);
    useEffect(() => {
        if (pagado > total) {
            let sal = pagado - total;
            setFormValue({ ...values, saldo: parseFloat(sal), cargo: 0 });
        }
        if (pagado < total) {
            let car = total - pagado;
            setFormValue({ ...values, saldo: 0, cargo: parseFloat(car) });
        }
        if (pagado === total) {
            setFormValue({ ...values, saldo: 0, cargo: 0 });
        }
    }, [pagado]);
    useEffect(() => {
        setFormValue({
            ...values,
            pagado: total,
        });
    }, [total, costo, show]);
    const totalAdd = () => {
        let ms = parseInt(meses);
        const day = moment(fechapago).add(ms, 'M').format('YYYY-MM-DD');
        setBon(0);
        if (ms === 12) setBon(costo);
        setfecha(day);
        const fechaInicial = moment(fechapago);
        let nuevaFecha = fechaInicial.clone().add(ms, 'M'); // Clonar para no modificar la original

        // Si la nueva fecha cae en febrero y la fecha original tenía día 30 o 31, lo cambia al 1 de marzo
        if (nuevaFecha.month() === 1) {
            // 1 = Febrero en Moment.js
            const diaOriginal = fechaInicial.date();
            const maxDiaFebrero = nuevaFecha.daysInMonth(); // 28 o 29 dependiendo del año

            if (diaOriginal > maxDiaFebrero) {
                nuevaFecha = nuevaFecha.date(1).month(2); // Cambia a 1 de marzo
            }
        }

        // Formatear y actualizar estado
        const dayR = nuevaFecha.format('YYYY-MM-DD');
        setfecha(dayR);
    };
    const processTl = () => {
        let pa = tlcargo - tlsaldo;
        let subInternet = meses * costo;
        let sumOt = 0;
        for (const key in otros) {
            if (Object.hasOwnProperty.call(otros, key)) {
                const element = otros[key];
                if (element.dias > 0) {
                    sumOt = sumOt + meses * element.precio;
                } else {
                    sumOt = parseInt(sumOt) + parseInt(element.precio) * meses;
                }
            }
        }

        const totalPay = sumOt + subInternet + pa - bon;
        setTotal(totalPay);
    };
    const setPlan = (pl) => setPinfo(pl);
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if (send) return;
        setSend(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            if (pdf !== 'notprint') {
                toastId.current = toast('Generando PDF...', {
                    position: 'top-right',
                    icon: <Spinner aria-label="Default status example" />,
                });
            }
            const { id = 0 } = data.datos;
            let car = values.cargo;
            let sal = values.saldo;
            if (parseFloat(total) == parseFloat(values.pagado)) {
                car = 0;
                sal = 0;
            }
            const re = await fetchConToken(
                `factura/pay`,
                {
                    ...values,
                    saldo: sal,
                    cargo: car,
                    id_user: id,
                    fecha_corte: datos.fechapago,
                    id_a: auth.uid,
                    tlcargo,
                    tlsaldo,
                    print: pdf,
                    bon,
                    detalle: pinfo.descripcion,
                    total,
                    fechapago: fecha,
                    meses,
                    plan: pinfo,
                },
                'PUT'
            );
            //
            toast.dismiss(toastId.current);
            setResp(re);
            if (re.data) {
                printJS({
                    printable: re.data,
                    showModal: true,
                    type: 'pdf',
                    base64: true,
                });
            }
            if (re.ok) {
                reset();
                setfecha('');
                setMeses(0);
                setFolEx(false);
                setPdf('pos');
                setTotal('');
                setBon(false);
                onClear();
            }
        }

        setSend(false);
    };
    return (
        <div>
            {show && (
                <Card className="p-2">
                    <ModalScreen id={data?.datos?.id} />
                    <Row>
                        <Col>
                            <div className="d-flex flex-row mb-3">
                                <span className="">
                                    {tipo === 'FIBRA' ? (
                                        <img src={icoFib} alt="fiber" width="18px" />
                                    ) : (
                                        <i className="mdi mdi-wifi  mdi-24px text-primary  "></i>
                                    )}
                                </span>{' '}
                                <div className="text-uppercase mr-2 p-2">
                                    {nombre}{' '}
                                    <span
                                        className={classNames('badge', {
                                            'bg-success': estado === 'ACTIVO',
                                            'bg-danger': estado === 'SUSPENDIDO',
                                        })}>
                                        {estado}
                                    </span>
                                </div>
                            </div>{' '}
                        </Col>
                        <Col>
                            <b className="mx-2 text-12"> Plan Actual</b>
                            <span className={classNames('badge bg-primary')}> {pinfo.plan}</span>
                        </Col>
                        <Col>
                            <OverlayTrigger
                                trigger="click"
                                placement="left"
                                overlay={
                                    <Popover>
                                        <Popover.Header as="h3" className="text-center">
                                            Planes
                                            <br />
                                            <span className="text-info">
                                                (El cambio se relizara segun la fecha de corte)
                                            </span>
                                        </Popover.Header>

                                        <Popover.Body>
                                            <div className="row row-cols-2">
                                                {planes.map((us, i) => (
                                                    <div key={i + 'bgol'}>
                                                        {!us.disabled && (
                                                            <div className="col">
                                                                {' '}
                                                                <button
                                                                    key={us.id}
                                                                    type="button"
                                                                    style={{
                                                                        fontSize: '11px',
                                                                        width: '125px',
                                                                    }}
                                                                    onClick={() => setPlan(us)}
                                                                    className={`btn mb-1 ${
                                                                        speed.id === us.id && 'btn-success'
                                                                    } ${
                                                                        pinfo?.id === us.id && 'btn-info'
                                                                    } border border-primary-subtlet rounded-lg text-9 px-2 py-1.5 text-center font-bold inline-flex items-center   m-0.5`}>
                                                                    <i className="mdi mdi-wifi  text-primary  "></i>

                                                                    {us.nombre || us.plan}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </Popover.Body>
                                    </Popover>
                                }
                                rootClose={false}>
                                <Button>Cambiar Plan</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BadgetInternet
                                plan={pinfo.plan}
                                descripcion={pinfo.descripcion}
                                costo={pinfo.costo}
                                meses={meses}
                                total={meses * pinfo.costo}
                            />
                        </Col>

                        <Col>
                            {' '}
                            <BadOtros otros={otros} meses={meses} />
                        </Col>
                        <Col>
                            {' '}
                            {bon > 0 && (
                                <span className="text-white p-2 rounded" style={{ background: '#0990bb' }}>
                                    Bonificacion de 1 mes por pago anual ${bon}
                                </span>
                            )}{' '}
                        </Col>
                    </Row>
                    <BadCarSal cargos={cargos} saldos={saldos} />

                    <Row>
                        <Form noValidate validated={validated} onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    {' '}
                                    <Row>
                                        <Col xs={10}>
                                            <Form.Group className="mb-3" controlId="validationCustomrp1">
                                                <Form.Label>Forma de pago</Form.Label>
                                                <Form.Select
                                                    value={values.forma_pago}
                                                    name="forma_pago"
                                                    required
                                                    onChange={handleInputChange}>
                                                    <option value="Efectivo Oficina/Sucursal">
                                                        Efectivo Oficina/Sucursal
                                                    </option>

                                                    <option value="Deposito bancario">Deposito bancario</option>
                                                    <option value="Trasferencia bancaria">Trasferencia bancaria</option>
                                                    <option value="Deposito bancario 5512">
                                                        Deposito bancario 5512
                                                    </option>
                                                    <option value="Trasferencia bancaria 5512">
                                                        Trasferencia bancaria 5512
                                                    </option>

                                                    <option value="Oxxo">Oxxo</option>
                                                    <option value="Mercado pago">Mercado pago</option>
                                                    <option value="PayPal/Visa/Mastercard">
                                                        PayPal/Visa/Mastercard
                                                    </option>
                                                    <option value="OpenPay">OpenPay</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustomrp2">
                                                <Form.Label>Meses {meses}</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    min={1}
                                                    max={12}
                                                    required
                                                    value={meses}
                                                    name="meses"
                                                    onChange={(e) => setMeses(e.target.value)}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustomrp3">
                                                <Form.Label>Numero de trasacción</Form.Label>
                                                <Form.Control
                                                    required={folEx}
                                                    type="number"
                                                    value={values.folio}
                                                    name="folio"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustomrp4">
                                                <Form.Label>Proximo pago</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    value={fecha}
                                                    disabled
                                                    onChange={(e) => setfecha(e.target.value)}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                    </Row>
                                    <Row>
                                        <Form.Group className="mb-3" controlId="validationCustomrp5">
                                            <Form.Label>Notas</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                type="text"
                                                value={values.nota}
                                                name="nota"
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col className="mt-3">
                                            <div className="alert alert-success" role="alert">
                                                TOTAL <span className="alert-link">${total}</span>
                                            </div>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="validationCustomrp6">
                                                <Form.Label
                                                    className={`fw-bold ${
                                                        pagado < total ? 'text-danger' : 'text-black'
                                                    }`}>
                                                    Total a pagar
                                                </Form.Label>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        <BsCurrencyDollar />
                                                    </InputGroup.Text>
                                                    <Form.Control
                                                        type="number"
                                                        min={0}
                                                        className={`fw-bold ${
                                                            pagado < total
                                                                ? 'boder border-danger'
                                                                : 'boder border-success'
                                                        }`}
                                                        required
                                                        name="pagado"
                                                        onChange={handleInputChange}
                                                        value={values.pagado}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una cantidad a pagar
                                                    </Form.Control.Feedback>{' '}
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row>{' '}
                                    <Col>
                                        {pagado < total && (
                                            <div className="alert alert-danger d-flex align-items-center" role="alert">
                                                <div>
                                                    {' '}
                                                    <span className="font-medium">ERROR! </span>Esta ingresando un monto
                                                    menor al total de la factura.
                                                </div>
                                            </div>
                                        )}
                                        {pagado > total && (
                                            <div className="alert alert-warning d-flex align-items-center" role="alert">
                                                <div>
                                                    {' '}
                                                    <span className="font-medium">Saldo a favor! </span>Esta ingresando
                                                    un monto mayor al total de la factura, si registra el pago quedará
                                                    un saldo a favor del cliente de ${saldo}
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                    <Row>
                                        <Col>
                                            <div className="flex items-center my-2">
                                                <input
                                                    type="radio"
                                                    value="pos"
                                                    className="form-check-input"
                                                    checked={pdf === 'pos'}
                                                    onChange={(e) => setPdf(e.target.value)}
                                                />
                                                <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                    <AiFillPrinter /> Recibo POS
                                                </label>
                                            </div>
                                            <div className="flex items-center my-2">
                                                <input
                                                    type="radio"
                                                    value="recibo"
                                                    className="form-check-input"
                                                    checked={pdf === 'recibo'}
                                                    onChange={(e) => setPdf(e.target.value)}
                                                />
                                                <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                    <AiFillPrinter /> Recibo Normal
                                                </label>
                                            </div>
                                            <div className="flex items-center mb-1">
                                                <input
                                                    type="radio"
                                                    value="factura"
                                                    className="form-check-input"
                                                    checked={pdf === 'factura'}
                                                    onChange={(e) => setPdf(e.target.value)}
                                                />
                                                <label className="mx-1 flex justify-center items-center ml-2 text-sm text-primary fw-bold">
                                                    <AiFillPrinter /> Factura
                                                </label>
                                            </div>

                                            <div className="flex items-center mb-1">
                                                <input
                                                    type="radio"
                                                    value="notprint"
                                                    className="form-check-input text-danger"
                                                    checked={pdf === 'notprint'}
                                                    onChange={(e) => setPdf(e.target.value)}
                                                />
                                                <label className="mx-1 flex justify-center items-center ml-2 text-sm font-medium text-danger fw-bold">
                                                    <AiOutlineStop /> No imprimir
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {/* <Row></Row> */}
                            {send ? (
                                <Button color="info" disabled>
                                    <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                    Procesando pago...
                                </Button>
                            ) : (
                                <>
                                    <Button type="button" onClick={onClear} className="mx-2 btn btn-light">
                                        Cancelar
                                    </Button>

                                    <Button
                                        type="submit"
                                        variant={pagado < total ? 'secondary' : 'primary'}
                                        disabled={pagado < total ? true : false}>
                                        Cobrar
                                    </Button>
                                </>
                            )}
                        </Form>
                    </Row>
                </Card>
            )}
            <Toaster position="top-right" />
        </div>
    );
};

export default RegPago;
